import { api } from '../axios.helper';
import { DocumentDto, FileReturnModel, Config } from '@ecdlink/core';
import { DocumentInput } from '@ecdlink/graphql';
class DocumentService {
  _accessToken: string;

  constructor(accessToken: string) {
    this._accessToken = accessToken;
  }

  async getdocuments(userId: string): Promise<DocumentDto[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'GetAllDocument',
      variables: {
        createdUserId: userId,
      },
    });

    if (response.status !== 200) {
      throw new Error('Getting Documents failed - Server connection error');
    }

    return response.data.data.GetAllDocument;
  }

  async getDocumentsForHCW(
    latestDocDate?: Date | null
  ): Promise<DocumentDto[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { documentsForHCW: DocumentDto[] };
      errors?: {};
    }>(``, {
      id: 'GetDocumentsForHCW',
      variables: {
        latestDocDate: latestDocDate,
      },
    });

    if (response.status !== 200) {
      throw new Error('Getting Documents failed - Server connection error');
    }
    return response.data.data.documentsForHCW;
  }

  async updateDocument(id: string, input: DocumentInput): Promise<boolean> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'updateDocument',
      variables: {
        id: id,
        input: input,
      },
    });

    if (response.status !== 200) {
      throw new Error('Updating document failed - Server connection error');
    }

    return true;
  }

  async fileUpload(
    file: string,
    fileName: string,
    fileType: string
  ): Promise<FileReturnModel> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'fileUpload',
      variables: {
        file: file,
        fileName: fileName,
        fileType: fileType,
      },
    });

    if (response.status !== 200) {
      throw new Error('Creating document failed - Server connection error');
    }

    return response.data.data.fileUpload;
  }
}

export default DocumentService;
